import { render, staticRenderFns } from "./SidebarMenuAgent.vue?vue&type=template&id=6f6e61f6&"
import script from "./SidebarMenuAgent.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports